<template>
  <appointment-end
    v-if="event.item.event === 'appointment_end'"
    :event="(event as HistoryMessageItem<MessageCallAppointmentEnd>)"
    :light="light"
    @click="onClick"
  />
  <appointment-start
    v-else-if="event.item.event === 'appointment_start'"
    :event="(event as HistoryMessageItem<MessageCallAppointmentStart>)"
  />
  <call-action
    v-else-if="
      event.item.event === 'call_missed' ||
        event.item.event === 'dialing_busy' ||
        event.item.event === 'call_ended' ||
        event.item.event === 'dialing_terminated' ||
        event.item.event === 'call_forwarded'
    "
    :light="light"
    :event="(event as HistoryMessageItem<MessageCallMissed | MessageCallBusy | MessageCallEnded | MessageCallTerminated | MessageCallForwarded>)"
    :next="nextChatEvent!"
  />
  <create-conference-from-dialog-failed
    v-else-if="event.item.event === 'create_conference_from_dialog_failed'"
    :event="(event as HistoryMessageItem<MessageCallFailed>)"
  />
</template>

<script setup lang="ts">
import {
  HistoryMessageItem,
  MessageCallAppointmentEnd,
  MessageCallReceived,
  MessageCallAppointmentStart,
  MessageCallMissed,
  MessageCallBusy,
  MessageCallEnded,
  MessageCallTerminated,
  MessageCallFailed,
  MessageCallForwarded,
} from '@wui/im'

import AppointmentEnd from './appointment-end.vue'
import AppointmentStart from './appointment-start.vue'
import CallAction from './call-action.vue'
import CreateConferenceFromDialogFailed from './create-conference-from-dialog-failed.vue'

defineProps<{
  event: HistoryMessageItem<MessageCallReceived>,
  nextChatEvent?: HistoryMessageItem,
  light: boolean,
}>()

const emit = defineEmits<{
  (event: 'appointment-event-click', value: {
    e: MouseEvent | TouchEvent,
    message: string
  }): void
}>()

const onClick = (payload: {
    e: MouseEvent | TouchEvent,
    message: string
  }) => {
  emit('appointment-event-click', payload)
}
</script>
